import { getView, requireAuth } from '@/lib/utils';
import {
  ChemicalDetailsPage,
  ChemicalAssetPage,
  ChemicalFilesPage,
  PageChemicalEdit,
} from '@/data/appInformationItems';
import { Left } from 'Models/Menu/menus';

export default {
  path: '/chemical/:_key',
  name: 'chemical',
  component: getView('pages/PageChemical'),
  redirect: { name: 'chemical-details' },
  meta: {
    roles: ['operator'],
  },
  children: [
    {
      path: 'details',
      name: 'chemical-details',
      component: getView('chemicals/TabDetails'),
      beforeEnter: requireAuth,
      meta: {
        crumbs: 'Chemicals > Details',
        leftMenu: Left.ChemicalDetails,
        information: ChemicalDetailsPage,
        showBottomMenu: true,
      },
    },
    {
      path: 'assets',
      name: 'chemical-assets',
      component: getView('chemicals/TabDetails'),
      beforeEnter: requireAuth,
      meta: {
        crumbs: 'Chemicals > Assets',
        leftMenu: Left.ChemicalAsset,
        information: ChemicalAssetPage,
        showBottomMenu: true,
      },
    },
    {
      path: 'chemical',
      name: 'chemical-jobs',
      component: getView('chemicals/TabDetails'),
      beforeEnter: requireAuth,
      meta: {
        crumbs: 'Chemicals > Jobs',
        leftMenu: Left.ChemicalDetails,
        information: ChemicalDetailsPage,
        showBottomMenu: true,
      },
    },
    {
      path: 'files',
      name: 'chemical-files',
      component: getView('chemicals/TabFiles'),
      beforeEnter: requireAuth,
      meta: {
        crumbs: 'Chemicals > Files',
        leftMenu: Left.ChemicalFiles,
        information: ChemicalFilesPage,
        showBottomMenu: true,
      },
    },
    {
      path: 'edit',
      name: 'chemicalEdit',
      component: getView('pages/PageChemicalEdit'),
      beforeEnter: requireAuth,
      meta: {
        crumbs: 'Chemicals > Edit',
        leftMenu: Left.ChemicalList,
        information: PageChemicalEdit,
        showBottomMenu: true,
      },
    },
  ],
};
